function getParent(el) {
	return el ? el.parentNode.parentNode : false;
}

/*=============================
=         Form Process        =
=============================*/

var fileField = document.getElementById('file-dropzone');

if(fileField) {
  var maxFiles = fileField.getAttribute('data-max-files');
  var maxFilesize = fileField.getAttribute('data-max-filesize');

  var fileDrop = new window.Dropzone.Dropzone('#file-dropzone', {
      maxFiles: maxFiles ? parseInt(maxFiles) : 1,
      maxFilesize: maxFilesize ? parseInt(maxFilesize) : 50,
      autoProcessQueue: false,
      addRemoveLinks: true,
      url: "/process-form",
      dictDefaultMessage: 'Drag-and-drop files here or click to select from your computer'
    });
}

var formMessage = document.getElementById('form-message');

[].slice.call(document.querySelectorAll('.ajax-form')).forEach(function(form) {
	form.addEventListener('submit', formProcess);
});

function formProcess(e) {
	if('performance' in window === false)
		return true;

	e.preventDefault();

	var form = this,
		ax = axios.create({
		headers: {
			'X-Requested-With': 'XMLHttpRequest'
		}
		}),
		data = new FormData(form),
		button = this.querySelector('button[type="submit"]');

	if(fileField && fileDrop) {
		var files = fileDrop.files.filter(function(f) { return f.accepted; });
		
		for(var f=0; f<files.length; f++)
			data.append('file'+f, files[f])
			
	}

	button.classList.add('disabled');

	for (var p of data) {
		let name = p[0];
		let value = p[1];

		try {
			if(document.querySelector('[for='+name+']')){
				
				data.append( name+'_nice', document.querySelector('[for='+name+']').childNodes[0].nodeValue.trim());

			} 
		} catch {
			continue;
		}
		
	}

	data.append('c_time', performance.now() >= 7000 ? 0 : 1);

	ax.post(form.action, data)
		.then(function(r) {
			Velocity(form, 'slideUp', {duration: 500, delay: 500});
			clearErrors(form);
			formMessage.classList.add('success');
			formMessage.innerHTML = r.data.message;

			if(typeof dataLayer !== 'undefined')
				dataLayer.push({'event': 'FormSubmission'});
		})
		.catch(function (e) {
			setTimeout(function() {
				button.classList.remove('disabled');
			}, 500);

			formMessage.classList.add('error');
			formMessage.innerHTML = e.response.data.message;

			if(e.response.status===422) {
				clearErrors(form);
				setErrors(form, e.response.data.errors);
			}
		});
}

function clearErrors(form) {
	var errors = form.getElementsByClassName('error');

	for(var e=errors.length - 1; e>=0; e--)
		errors[e].classList.remove('error');

	Velocity(formMessage, 'scroll', {
		duration: 500,
		offset: -header.offsetHeight
	});
}

function setErrors(form, errors) {
	var firstField = false;

	if(Object.keys(errors).length) {
		var errorsList = document.createElement('ul');

	    formMessage.appendChild(errorsList);
	}

	for(var key in errors) {
		var label = form.querySelector('label[for="'+key+'"]');

		if(label)
			label.parentNode.classList.add('error');

		if(key == 'g-recaptcha-response')
			document.querySelector('.g-recaptcha').classList.add('error');

		var field = form.querySelector('*[name="'+key+'"]');

        field.setAttribute('aria-describedby', key+'_error');

		if(!firstField) {
			field.focus();
			firstField = true;
		}

		var li = document.createElement('li');

        li.setAttribute('id', key+'_error');
        li.innerHTML = errors[key];
        errorsList.appendChild(li);
	}
}